import { createAction } from 'redux-actions';
import Types from './types';

export const registerRoleRequest = createAction(Types.REGISTER_ROLE_REQUEST);
export const registerRoleFulfilled = createAction(
  Types.REGISTER_ROLE_FULFILLED
);
export const registerRoleRejected = createAction(Types.REGISTER_ROLE_REJECTED);

export const editRoleRequest = createAction(Types.EDIT_ROLE_REQUEST);
export const editRoleFulfilled = createAction(Types.EDIT_ROLE_FULFILLED);
export const editRoleRejected = createAction(Types.EDIT_ROLE_REJECTED);

export const getAllRolesRequest = createAction(Types.GET_ALL_ROLES_REQUEST);
export const getAllRolesFulfilled = createAction(Types.GET_ALL_ROLES_FULFILLED);
export const getAllRolesRejected = createAction(Types.GET_ALL_ROLES_REJECTED);

export const resetGroupsSearch = createAction(Types.RESET_GROUPS_SEARCH);

export const removeRolesRequest = createAction(Types.REMOVE_ROLES_REQUEST);
export const removeRolesFulfilled = createAction(Types.REMOVE_ROLES_FULFILLED);
export const removeRolesRejected = createAction(Types.REMOVE_ROLES_REJECTED);

export const getRoleInfoRequest = createAction(Types.GET_ROLE_INFO_REQUEST);
export const getRoleInfoFulfilled = createAction(Types.GET_ROLE_INFO_FULFILLED);
export const getRoleInfoRejected = createAction(Types.GET_ROLE_INFO_REJECTED);

export const getAllObjectsRequest = createAction(Types.GET_ALL_OBJECTS_REQUEST);
export const getAllObjectsFulfilled = createAction(
  Types.GET_ALL_OBJECTS_FULFILLED
);
export const getAllObjectsRejected = createAction(
  Types.GET_ALL_OBJECTS_REJECTED
);

export const getObjectsRequest = createAction(Types.GET_OBJECTS_REQUEST);
export const getObjectsFulfilled = createAction(Types.GET_OBJECTS_FULFILLED);
export const getObjectsRejected = createAction(Types.GET_OBJECTS_REJECTED);

export const getObjectsAvailableRequest = createAction(
  Types.GET_OBJECTS_AVAILABLE_REQUEST
);
export const getObjectsAvailableFulfilled = createAction(
  Types.GET_OBJECTS_AVAILABLE_FULFILLED
);
export const getObjectsAvailableRejected = createAction(
  Types.GET_OBJECTS_AVAILABLE_REJECTED
);

export const registerObjectsRequest = createAction(
  Types.REGISTER_OBJECTS_REQUEST
);
export const registerObjectsFulfilled = createAction(
  Types.REGISTER_OBJECTS_FULFILLED
);
export const registerObjectsRejected = createAction(
  Types.REGISTER_OBJECTS_REJECTED
);

export const removeObjectsRequest = createAction(Types.REMOVE_OBJECTS_REQUEST);
export const removeObjectsFulfilled = createAction(
  Types.REMOVE_OBJECTS_FULFILLED
);
export const removeObjectsRejected = createAction(
  Types.REMOVE_OBJECTS_REJECTED
);

export const getPermissionsRequest = createAction(
  Types.GET_PERMISSIONS_REQUEST
);
export const getPermissionsFulfilled = createAction(
  Types.GET_PERMISSIONS_FULFILLED
);
export const getPermissionsRejected = createAction(
  Types.GET_PERMISSIONS_REJECTED
);

export const registerPermissionsRequest = createAction(
  Types.REGISTER_PERMISSIONS_REQUEST
);
export const registerPermissionsFulfilled = createAction(
  Types.REGISTER_PERMISSIONS_FULFILLED
);
export const registerPermissionsRejected = createAction(
  Types.REGISTER_PERMISSIONS_REJECTED
);

export const toggleAddAllObjectsRequest = createAction(
  Types.TOGGLE_ADD_ALL_OBJECTS_REQUEST
);
export const toggleAddAllObjectsFulfilled = createAction(
  Types.TOGGLE_ADD_ALL_OBJECTS_FULFILLED
);
export const toggleAddAllObjectsRejected = createAction(
  Types.TOGGLE_ADD_ALL_OBJECTS_REJECTED
);

export const cloneRoleRequest = createAction(Types.CLONE_ROLE_REQUEST);
export const cloneRoleFulfilled = createAction(Types.CLONE_ROLE_FULFILLED);
export const cloneRoleRejected = createAction(Types.CLONE_ROLE_REJECTED);
